import { render, staticRenderFns } from "./ArticleAdd.vue?vue&type=template&id=d20247f4&"
import script from "./ArticleAdd.vue?vue&type=script&lang=ts&"
export * from "./ArticleAdd.vue?vue&type=script&lang=ts&"
import style0 from "./ArticleAdd.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports